import { FaUtensils, FaConciergeBell, FaLeaf, FaCalendarCheck } from 'react-icons/fa';

const features = [
    {
        id: 1,
        icon: <FaUtensils />, // Utensils icon
        title: 'Fine Dining',
        description: 'Experience exquisite meals in a sophisticated setting.',
    },
    {
        id: 2,
        icon: <FaConciergeBell />, // Concierge bell icon
        title: 'Custom Catering',
        description: 'Tailored catering services for any event or occasion.',
    },
    {
        id: 3,
        icon: <FaLeaf />, // Leaf icon
        title: 'Seasonal Menus',
        description: 'Menus featuring fresh, seasonal ingredients for optimal flavor.',
    },
    {
        id: 4,
        icon: <FaCalendarCheck />, // Calendar check icon
        title: 'Online Reservations',
        description: 'Easy online booking for a hassle-free dining experience.',
    },
];

export default features;